import React, {Component} from 'react'
import PrintPreview from '../PrintPreview'
import PdfStore from '../../../stores/PdfStore'
import './PGA.css'
// import { Radio, Checkbox } from 'react-icheck'
var NotificationSystem = require('react-notification-system');
class PrintPGABorrowingBackupcarDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {
			loading:false,
			data:{},
			page_title:'กำลังดึงข้อมูล..'
		}
    
    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    this.loadData()
  }

  loadData() {
  	this.setState({loading:true})
 		PdfStore.loadBorrowingBackupCarDoc(this.props.wo,(result)=>{
			this.setState({loading:false,data:result.data,page_title:'ไม่พบข้อมูล'})
		},()=>{
			this.setState({loading:false,page_title:'ไม่พบข้อมูล'})
		})
  }

  renderLogoUrl(logoUrl){
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    if(logoUrl!==undefined)
      return (<img src={imgUrl} />)
    else
      return ('')
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
	}
	
	renderTitle() {
		return(
				<div className='header-title'>
					ใบแจ้งการยืมรถสำรองใช้ระหว่างซ่อม
				</div>
		)
	}

	renderBody() {
		let {data} = this.state
		return(
				<div>
					<table className='table table-no-bd' style={{marginTop:'20px'}}>
						<tbody>
							<tr>
								<td className='text-left'>
									ชื่อ-สกุลผู้ยืม: &nbsp;
									<span style={{width:'200px',borderBottom:'1px solid #111',display:'inline-block'}}>{data.receiving?data.receiving.entrance_name:''}</span>
									เบอร์ติดต่อ: &nbsp;
									<span style={{width:'120px',borderBottom:'1px solid #111',display:'inline-block'}}>{data.receiving?data.receiving.tel:''}</span>
									No. VIP: &nbsp;
									<span style={{width:'50px',borderBottom:'1px solid #111',display:'inline-block'}}>{data.receiving?data.receiving.vip_no:''}</span>
								</td>
							</tr>
							<tr>
								<td className='text-left'>
									รถจอดซ่อม: &nbsp;
									<span style={{width:'110px',borderBottom:'1px solid #111',display:'inline-block'}}>{data.car?data.car.brand:''}{data.car?'/':''}{data.car?data.car.model:''}</span>
									ทะเบียน: &nbsp;
									<span style={{width:'100px',borderBottom:'1px solid #111',display:'inline-block'}}>{data.car?data.car.car_registration_no:""}</span>
									มีเคลมเป็นฝ่าย: &nbsp;
									<span style={{width:'80px',borderBottom:'1px solid #111',display:'inline-block'}}>{data.car?data.car.accident_type:''}</span>
								</td>
							</tr>
							<tr>
								<td className='text-left'>
									บริษัทประกัน: &nbsp;
									<span style={{width:'500px',borderBottom:'1px solid #111',display:'inline-block'}}>{data.insurer?data.insurer.insurer_name:''}</span>
								</td>
							</tr>
							<tr>
								<td className='text-left'>
									รถยืมไปใช้: &nbsp;
									<span style={{width:'90px',borderBottom:'1px solid #111',display:'inline-block'}}>{data.backupcar?data.backupcar.brand_model:''}</span>
									ทะเบียน: &nbsp;
									<span style={{width:'60px',borderBottom:'1px solid #111',display:'inline-block'}}>{data.backupcar?data.backupcar.ref_no:''}</span>
								</td>
							</tr>
							<tr>
								<td className='text-left'>
									วันที่รับรถ: &nbsp;
									<span style={{width:'80px',borderBottom:'1px solid #111',display:'inline-block'}}>{data.receiving?data.receiving.entrance_date:''}</span>
									เวลารับ: &nbsp;
									<span style={{width:'50px',borderBottom:'1px solid #111',display:'inline-block'}}>{data.receiving?data.receiving.entrance_time:''}</span>
								</td>
							</tr>
						</tbody>
					</table>
					<div style={{position:'relative'}}> 
						<div style={{position:'absolute',right:'0',top:'-72px'}}> 
							<table className='table table-side' style={{marginBottom:'0'}}>
								<tbody>
									<tr>
										<td className='text-center bd-r' style={{width:'150px'}}>อุปกรณ์ติดรถยนต์มาตราฐาน</td>
										<td className='text-center bd-r' style={{width:'80px'}}>ปริมาณน้ำมัน</td>
										<td className='text-center bd-r' style={{width:'80px'}}>เลขไมล์กิโล</td>
										<td className='text-center' style={{width:'80px'}}>หมายเหตุอื่นๆ</td>
									</tr>
									<tr>
										<td className='bd-r'>
											<span style={{width:'40px',borderBottom:'1px solid #111',display:'inline-block'}}></span>
											เครื่องมือ &nbsp;
											<span style={{width:'40px',borderBottom:'1px solid #111',display:'inline-block'}}></span>
											อะไหล่
										</td>
										<td className='bd-r'></td>
										<td className='bd-r'></td>
										<td></td>
									</tr>
									<tr>
										<td className='bd-r'>
											<span style={{width:'40px',borderBottom:'1px solid #111',display:'inline-block'}}></span>
											แม่แรง &nbsp;
											<span style={{width:'40px',borderBottom:'1px solid #111',display:'inline-block'}}></span>
											ยางปูพื้น
										</td>
										<td className='bd-r'></td>
										<td className='bd-r'></td>
										<td></td>
									</tr>
								</tbody>
							</table>		
						</div>	
					</div>
					<div className='header-title' style={{marginBottom:'10px'}}>
						<u>** หมายเหตุให้ลูกค้ารับทราบ **</u>
					</div>
					<div style={{marginBottom:'10px'}}>
						- ลูกค้านำรถสำรองไปใช้เกิดอุบัติเหตุ สามารถแแจ้งพนักงานเคลมบริษัทประกันได้ทันที (เบอร์โทรบริษัทประกันอยู่ในซองเอกสารที่เก๊ะหน้ารถด้านซ้าย <br />
						- ลูกค้านำรถสำรองใช้ไปเกิดอุบัติเหตุแบบไม่มีคู่กรณี หรือ เจ้าหน้าที่พิจารณาแล้วว่าเป็นฝ่ายผิด ลูกค้าต้องรับผิดชอบค่าเสียหายส่วนแรก 2,000 บาท <br />
						- ลูกค้านำรถสำรองไปใช้แล้วมีรอยครูด, แตกหัก, รวมถึงชำรุด สูญหาย ไม่เป็นสภาพเดิม ลูกค้าต้องรับผิดชอบค่าเสียหายส่วนแรก 2,000.- หรือเทียบเท่า <br />
						- ลูกค้านำรถสำรองใช้ไปผิดกฎจราจร ทำให้ได้รับเอกสารหรือใบสั่ง ลูกค้าต้องรับผิดชอบค่าปรับตามที่ระบุในใบสั่งรวมกับค่าธรรมเนียม (ถ้ามี)
					</div>
					<div className='header-title'>
						<u>** หากมีการใช้รถเกินจำนวนวันที่เจ้าหน้าที่ระบุ คิดค่าเช่าวันละ 599 บาท ทุกกรณี **</u>
					</div>
					<table className='table table-no-bd' style={{marginTop:'20px',marginBottom:'0'}}>
						<tbody>
							<tr>
								<td className='text-left'>
									ใช้ฟรี: &nbsp;
									<span style={{width:'60px',borderBottom:'1px solid #111',display:'inline-block'}}>{data.backupcar?data.backupcar.used_duration:''}</span> วัน &nbsp;&nbsp;&nbsp;
									ใช้ฟรีตั้งแต่วันที่: &nbsp;
									<span style={{width:'150px',borderBottom:'1px solid #111',display:'inline-block'}}>{data.backupcar?data.backupcar.start_date:''}</span> &nbsp;
									ถึงวันที่: &nbsp;
									<span style={{width:'150px',borderBottom:'1px solid #111',display:'inline-block'}}>{data.backupcar?data.backupcar.end_date:''}</span>
								</td>
							</tr>
						</tbody>
					</table>	
					<div className='header-title'>
						ลูกค้ายืนยันรับทราบและเข้าใจเงื่อนไขตามที่แจ้งทุกประการ
					</div>
					<table className='table table-no-bd' style={{marginTop:'20px',marginBottom:'0'}}>
						<tbody>
							<tr>
								<td className='text-center'>
									ลูกค้ารับทราบ: &nbsp;
									<span style={{width:'110px',borderBottom:'1px solid #111',display:'inline-block'}}></span> &nbsp;
									เจ้าหน้าที่: &nbsp;
									<span style={{width:'110px',borderBottom:'1px solid #111',display:'inline-block'}}></span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
		)
	}

  renderComponentPage() {
    return(
      <div className='font-print print-pga-borrowing'>
				<div className='form-0' style={{marginBottom:'50px'}}>
					{this.renderTitle()}
					{this.renderBody()}	
				</div>
				<hr className='hr-h' />
				<div className='form-1' style={{marginTop:'50px'}}>
					{this.renderTitle()}
					{this.renderBody()}	
				</div>
      </div>  
    )
  }

  render() {
    let {loading} = this.state
    return(
      <div>
        <PrintPreview
          loading={loading}
          leftBarTitle={this.props.title}
          showPageNumber={false}
        >
          {this.renderComponentPage()}
        </PrintPreview>
        <NotificationSystem ref="notificationSystem" />
      </div>
    ) 
  }
}  

PrintPGABorrowingBackupcarDoc.defaultProps = {
  title:'',  
  mode:''
}
export default PrintPGABorrowingBackupcarDoc;


// WEBPACK FOOTER //
// ./src/view/print/pga/PrintPGABorrowingBackupcarDoc.js